import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Switch, Route } from 'react-router';

//import '../../assets/css/animate.css';
//import './assets/css/styles.css'
// import routes from './routes';
import store, {history} from './store/store';
import ErrorBoundary from './ErrorBoundary';
import MasterContainer from './containers/MasterContainer/MasterContainer';
import { initializeGTM } from './common/analytics'
import OneTimeLoginContainer from './containers/OneTimeLoginContainer/OneTimeLoginContainer';
initializeGTM();




/*const LoginContainer = AsyncComponent(() => import('./containers/LoginContainer/LoginContainer').then(module => module.default));
const PasswordResetRequestContainer = AsyncComponent(() => import('./containers/PasswordResetRequestContainer/PasswordResetRequestContainer').then(module => module.default));
const PasswordResetContainer = AsyncComponent(() => import('./containers/PasswordResetContainer/PasswordResetContainer').then(module => module.default));
const HomeContainer = AsyncComponent(() => import('./containers/HomeContainer/HomeContainer').then(module => module.default));*/

ReactDOM.render(
    <ErrorBoundary>
        <Provider store={store}>
            <Router history={history}>
                <Switch>
                    <Route exact path="/login/:token" component={OneTimeLoginContainer} />
                    <Route path="/*" component={MasterContainer} />
                    {/*<Route exact path="/password-reset" component={PasswordResetRequestContainer} />
                    <Route exact path="/password-reset/:passwordResetHash" component={PasswordResetContainer} />
                    <Route path="/home" component={HomeContainer} />*/}
                </Switch>
            </Router>
        </Provider>
    </ErrorBoundary>
    , document.getElementById('root'));


//TODO:Will be implemented later
//if('serviceWorker' in navigator) {
//    console.log('Service Worker Found');
//
//    navigator.serviceWorker
//        .register('./serviceWorker.js', { scope: './'})
//        .then(function(registration){
//            console.log('Service Worker Registered ');
//        })
//        .catch(function(err){
//            console.log('Service Worker Fail to Register ',err);
//        });
//}
